import React from 'react';
import './style.scss';
import _ from 'lodash';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { type Filter } from '../..';
import { Chart, ArcElement } from 'chart.js';
import DashboardBox, { ALLOW_ALL } from '../../components/DashboardBox';

Chart.register(ArcElement);

const TechnologySection = ({ filter }: { filter: Filter }) => {
  const dispatch = useAppDispatch();
  return (
    <div className="technology-section relative">
      <DashboardBox
        title="Sessions by Platform"
        info="Number of users sessions by platform"
        allow={ALLOW_ALL}
      >
        <div className="auto-two-cols">TODO</div>
      </DashboardBox>
    </div>
  );
};

export default TechnologySection;
